module.exports = __webpack_public_path__ + "static/media/Story_wo CTA.f0b39826.jpg";